import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import elementType from 'prop-types-extra/lib/elementType';
import cns from 'classnames';

import Icon from 'components/icons/ChevronRightIcon.com.svg';
import withRestProps from 'helpers/withRestProps';

import cn from './styles.local.less';

const propTypes = {
  Body: elementType.isRequired,
  initialOpened: PropTypes.bool,
  label: PropTypes.string.isRequired,
  qaSelector: PropTypes.string,
  rest: PropTypes.object,
};

class Item extends PureComponent {
  static propTypes = propTypes;

  static defaultProps = {
    initialOpened: false,
  };

  state = {
    isOpened: this.props.initialOpened,
  };

  handleLabelClick = () => {
    const { isOpened } = this.state;

    this.setState({ isOpened: !isOpened });
  };

  handleKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();

      this.handleLabelClick();
    }
  };

  render() {
    const { isOpened } = this.state;
    const { label, Body, rest, qaSelector } = this.props;

    return (
      <div
        className={cns(cn.root, { [cn.open]: isOpened })}
        data-qa-selector={qaSelector}
      >
        <div
          className={cn.label}
          onClick={this.handleLabelClick}
          onKeyDown={this.handleKeyDown}
          tabIndex={0}
          role="button"
        >
          <span className={cn.labelText}>{label}</span>
          <Icon className={cn.icon} />
        </div>
        <div className={cns(cn.body, 'clearfix')}>
          {isOpened && <Body {...rest} />}
        </div>
      </div>
    );
  }
}

export default withRestProps()(Item);
